module.exports = __webpack_public_path__ + "img/code.767d8d01.png";